<div class="notificationHolder">
  @for (notification of notificationExtract$ | async; track notification) {
    @if (notification.showDataStatus) {
      @if (dataDateExtract$ | async; as data) {
        <div class="hods-alert" [class]="isDataUptodate(data) ? 'error' : ''">
          <h2 class="hods-alert__heading">Date information uploaded</h2>
          @if (isDataUptodate(data)) {
            <div class="error">Not Up-to-date</div>
          }
          <p>{{ data.details | date: 'dd/MM/yyyy' }}</p>
        </div>
      }
    }
  }
</div>
